"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { ROUTES } from "@/config/routes/paths";
import { decodeJwtExpWithBuffer } from "@/utils/token";

export default function RootPage() {
  const router = useRouter();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token && decodeJwtExpWithBuffer(token, 60)) {
      router.replace(ROUTES.CLIENT.LIST);
    } else {
      localStorage.removeItem("access_token");
      localStorage.removeItem("userid");
      localStorage.removeItem("username");
      router.replace(ROUTES.LOGIN);
    }
  }, [router]);

  return null;
}
